import React from 'react'

import DotIcon from '../../../assets/icons/dot.svg'
import styles from './Dots.module.scss'

export type DotsProps = {
  colors: string[]
}
const Dots: React.FC<React.PropsWithChildren<DotsProps>> = ({ colors }) => {
  return (
    <span className={styles.root}>
      {colors.slice(0, 3).map((color, idx) => (
        <DotIcon key={idx} fill={color} />
      ))}
    </span>
  )
}

export default Dots
